<template>
  <div class="loading-container">
    <h1 class="loading-title">2026 PCA Parade</h1>
    <img
      ref="gifImage"
      src="@/assets/gif/wheel_spinner_loading.gif"
      alt="cartoon porsche driving"
      class="loading-img"
    />
    <p class="loading-caption">loading...</p>
  </div>
</template>

<script lang="ts">
// Vue
import { defineComponent, ref, onMounted, onUnmounted } from 'vue';

export default defineComponent({
  name: 'LoadingCarWheelSpinner',
  setup() {
    const gifImage = ref<HTMLImageElement | null>(null);
    let reloadInterval: number | null = null;

    const restartGif = () => {
      if (gifImage.value) {
        // Reset the gif src to restart the animation (it doesn't loop otherwise)
        const currentSrc: string = gifImage.value.src.split('?')[0];
        gifImage.value.src = '';
        requestAnimationFrame(() => {
          if (gifImage.value) {
            gifImage.value.src = currentSrc;
          }
        });
      }
    };

    onMounted(() => {
      // Reload the gif periodically to ensure it loops continuously
      reloadInterval = window.setInterval(restartGif, 5000);
    });

    onUnmounted(() => {
      if (reloadInterval !== null) {
        clearInterval(reloadInterval);
      }
    });

    return {
      gifImage,
    };
  },
});
</script>

<style scoped lang="scss">
.loading-img {
  height: 100px;
  margin-top: 40px;
}

.loading-container {
  align-items: center;
  background-color: $secondary;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  width: 100%;
}

.loading-title {
  color: $pca-blue;
  font-family: 'Saira Condensed', sans-serif;
  font-size: 50px;
  font-weight: 600;
  margin-top: -10%;
  text-shadow: 1px 1px 1px $pca-red;
  z-index: 100;
}

.loading-caption {
  color: $pca-dark-grey;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
}
</style>
